import { BodyImageContainer } from "../domain/bodyimage";
import { Header } from "../utilities/Header";
import { Footer } from "../utilities/Footer";

const IndexPage: React.FC = () => {
	return (
		<>
			<section id="section-main" className="section section-main">
				<div className="container-fluid">
					<Header />
					<BodyImageContainer />
				</div>
			</section>
			<Footer />
		</>
	);
};

export { IndexPage };
